(function () {
  'use strict';

  /* @ngdoc object
   * @name testdata
   * @description
   *
   */
  angular
    .module('testdata', [
      'ui.router'
    ]);
}());
